
export const operates = {
  // 系统管理员 roleId
  1: {
    admin: [
      { value: 2, name: '重置密码' },
      { value: 3, name: '修改' },
      // { value: 4, name: '删除' }
    ],
    supervisor: [
      { value: 1, name: '设置权限' },
      { value: 2, name: '重置密码' },
      { value: 3, name: '修改' },
      // { value: 4, name: '删除' }
    ],
    user: [
      { value: 3, name: '修改' },
      // { value: 4, name: '删除' }
    ]
  },
  // 省
  2: {
    admin: [
      { value: 3, name: '修改' },
      // { value: 4, name: '删除' }
    ],
    supervisor: [
      { value: 1, name: '设置权限' },
      { value: 3, name: '修改' },
      // { value: 4, name: '删除' }
    ]
  },
  // 市
  3: {
    admin: [
      { value: 3, name: '修改' },
      { value: 4, name: '删除' }
    ],
    supervisor: [
      { value: 1, name: '设置权限' },
      { value: 3, name: '修改' },
      // { value: 4, name: '删除' }
    ]
  },
  // 区
  4: {
    admin: [
      { value: 3, name: '修改' },
      // { value: 4, name: '删除' }
    ],
    supervisor: [
      { value: 1, name: '设置权限' },
      { value: 3, name: '修改' },
      // { value: 4, name: '删除' }
    ]
  }
}
